import { NavigateBackLink } from '@exam-center/components';
import { Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useExamCenterProctorDetails } from '../../providers';

interface ExamCenterProctorDetailsHeaderProps {
  examCenterCode: string;
}

export default function ExamCenterProctorDetailsHeader(
  props: Readonly<ExamCenterProctorDetailsHeaderProps>,
) {
  const { examCenterCode } = props;
  const { proctor } = useExamCenterProctorDetails();

  const title = [proctor.titleTh, proctor.firstNameTh, proctor.middleNameTh, proctor.lastNameTh]
    .filter(Boolean)
    .join(' ');

  const updatedUserFullName = [
    proctor.updatedUser?.firstname,
    proctor.updatedUser?.lastname,
  ].filter(Boolean);

  return (
    <PageHeader
      title={title}
      subtitleSection={
        <Flex
          sx={(theme) => ({
            flex: 1,
            gap: theme.spacing(4),
          })}
        >
          <Flex
            sx={(theme) => ({
              flex: 1,
              gap: theme.spacing(4),
            })}
          >
            <Text
              variant='body2'
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            >
              ศูนย์ทดสอบ: {proctor.examCenterCode}
            </Text>
            <Text
              variant='body2'
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            >
              วันที่อนุมัติคำขอ: {formatDateTime(proctor.createdAt)}
            </Text>
          </Flex>
          <Flex
            sx={(theme) => ({
              flex: 1,
              gap: theme.spacing(4),
              justifyContent: 'flex-end',
            })}
          >
            <Text
              variant='body2'
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            >
              Last Updated: {formatDateTime(proctor.updatedAt)}
            </Text>
            <Text
              variant='body2'
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            >
              By: {updatedUserFullName.length ? updatedUserFullName.join(' ') : '-'}
            </Text>
          </Flex>
        </Flex>
      }
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-proctors/proctors'
          params={{
            examCenterCode,
          }}
        />
      }
    />
  );
}
